export type AdminCourseLike = {
  courseProject?: string | null;
  title?: string | Record<string, string> | null;
  defaultLanguage?: string | null;
};

export const getLocalizedCourseTitle = (
  title: string | Record<string, string> | null | undefined,
  defaultLanguage: string = 'en'
): string => {
  if (!title) return '';
  if (typeof title === 'string') return title;
  return title[defaultLanguage] || title.en || Object.values(title)[0] || '';
};

/** Localized field (chapter title, quiz question, etc.) using course default language first. */
export const getLocalizedField = (
  value: string | Record<string, string> | null | undefined,
  defaultLanguage: string = 'en',
  fallback = ''
): string => {
  if (!value) return fallback;
  if (typeof value === 'string') return value;
  return (
    value[defaultLanguage] ||
    value.en ||
    value.fr ||
    Object.values(value).find((v) => typeof v === 'string' && v.length > 0) ||
    fallback
  );
};

/** Admin-facing course identifier. Falls back to learner title for legacy rows. */
export const getAdminCourseName = (course: AdminCourseLike, fallback = 'Formation'): string => {
  const project = (course.courseProject || '').trim();
  if (project) return project;
  const localizedTitle = getLocalizedCourseTitle(course.title, course.defaultLanguage || 'en').trim();
  return localizedTitle || fallback;
};
